import React, { Component } from "react";
import { Link } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";

import Plus from "mdi-material-ui/Plus";

import moment from "moment";
import { Bar } from "react-chartjs-2";

import TableCellLink from "../../components/TableCellLink";
import DataTable from "../../components/DataTable";
import GatewayStore from "../../stores/GatewayStore";
import Button from '@material-ui/core/Button';

import theme from "../../theme";

const styles = {
  buttons: {
    textAlign: "right",
  },
  button: {
    marginLeft: 2 * theme.spacing(1),
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  chart: {
    width: 380,
  },
  tabs: {
    borderBottom: "1px solid " + theme.palette.divider,
    height: "48px",
    overflow: "visible",
  },
};

class GatewayRow extends Component {
  constructor() {
    super();

    this.state = {};
  }

  componentDidMount() {
    const start = moment().subtract(29, "days").toISOString();
    const end = moment().toISOString();

    GatewayStore.getStats(this.props.gateway.id, start, end, resp => {
      let stats = {
        labels: [],
        datasets: [
          {
            data: [],
            fillColor: "rgba(33, 150, 243, 1)",
          },
        ],
      };

      for (const row of resp.result) {
        stats.labels.push(row.timestamp);
        stats.datasets[0].data.push(row.rxPacketsReceivedOK + row.txPacketsEmitted);
      }

      this.setState({
        stats: stats,
      });
    });
  }

  render() {
    const options = {
      scales: {
        xAxes: [{display: false}],
        yAxes: [{display: false}],
      },
      tooltips: {
        enabled: false,
      },
      legend: {
        display: false,
      },
      responsive: false,
      animation: {
        duration: 0,
      },
    };

    let lastseen = "Never";
    if (this.props.gateway.lastSeenAt !== null) {
      lastseen = moment(this.props.gateway.lastSeenAt).fromNow();
    }

    return(
      <TableRow hover>
          <TableCell>{lastseen}</TableCell>
          <TableCellLink to={`/organizations/${this.props.gateway.organizationID}/gateways/${this.props.gateway.id}`}>{this.props.gateway.name}</TableCellLink>
          <TableCell>{this.props.gateway.id}</TableCell>
          <TableCell>{this.props.gateway.networkServerName}</TableCell>
          <TableCell>
            {this.state.stats && <Bar
              width={380}
              height={23}
              data={this.state.stats}
              options={options}
            />}
          </TableCell>
      </TableRow>
    );
  }
}


class ListGateways extends Component {
  getPage = (limit, offset, callbackFunc) => {
    GatewayStore.list("", this.props.match.params.organizationID, limit, offset, callbackFunc);
  }

  getRow = (obj) => {
    return(
      <GatewayRow key={obj.id} gateway={obj} />
    );
  }

  render() {
    return(
      <Grid container spacing={4}>
        {/* <TitleBar
          buttons={
            <GatewayAdmin organizationID={this.props.match.params.organizationID}>
              <TitleBarButton
                key={1}
                label="Create"
                icon={<Plus />}
                to={`/organizations/${this.props.match.params.organizationID}/gateways/create`}
              />
            </GatewayAdmin>
          }
        >
        <TitleBarTitle title="Gateways" />
        </TitleBar> */}

        <Grid item xs={12}>
          <DataTable
            header={
              <TableRow>
                <TableCell>Last seen</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Gateway ID</TableCell>
                <TableCell>Network server</TableCell>
                <TableCell className={this.props.classes.chart}>Gateway activity (30d)</TableCell>
              </TableRow>
            }
            getPage={this.getPage}
            getRow={this.getRow}
          />
        </Grid>

        {this.props.admin && (
          <Grid item xs={12} className={this.props.classes.buttons}>
            <Button variant="outlined" className={this.props.classes.button} component={Link} to={`/organizations/${this.props.organizationID}/gateways/create`}>
              <Plus className={this.props.classes.icon} />
                Add Gateway
              </Button>
          </Grid>
        )}

      </Grid>
    );
  }
}

export default withStyles(styles)(ListGateways);
